import { Box, styled } from "@mui/material";

export const DialogContentWrapper = styled(Box)`
  display: flex;
  flex-flow: column;
`;

export const AddCaseCodeInputWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: fit-content;
`;
